<template>
  <div class="login">
    <p
      style="
        text-align: center;
        margin: 0;
        padding-top: 30px;
        margin-bottom: 30px;
      "
    >
      <img src="static/logo.jpeg" width="130" />
    </p>
    <h2>Kendali Kerja</h2>

    <form @submit.prevent="login">
      <div class="form-group">
        <label>USER</label>
        <select v-model="param.id">
          <option></option>
          <option v-for="(item, index) in user" :key="index" :value="item.id">
            {{ item.nama }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>PASSWORD</label>
        <input type="password" v-model="param.password" />
      </div>
      <div>
        <button
          type="submit"
          :disabled="loading"
          :class="{ disabled: loading }"
        >
          Login
        </button>
      </div>
      <p v-if="failed" style="color: #f00; margin-bottom: 0">Login Gagal</p>
    </form>
  </div>
</template>

<script>
import * as api from "./../api/Api";

export default {
  name: "Home",
  data() {
    return {
      user: [],
      param: {},
      loading: false,
      failed: "",
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.failed = "";

      this.param.platform = "KENDALI_KERJA";

      api
        .post("/v1/SsoController/login", this.param)
        .then((r) => {
          this.loading = false;
          if (r.valid === true) {
            this.$store.commit("settings/setUser", r.data);
            this.failed = "";

            location.href = "./index.html";
          } else {
            this.failed = "Login Gagal";
          }
        })
        .catch((e) => {
          this.failed = "Kesalahan jaringan";
        });
    },
  },
  mounted() {
    api.get("/v1/users/getByPlatform?platform=KENDALI_KERJA").then((r) => {
      this.user = r;
      this.$store.commit("user/setData", r);
    });
  },
};
</script>

<style scoped lang="scss">
.login {
  background: #fff;

  h2 {
    text-align: center;
    line-height: 36px;
    margin: 30px 0px;
  }

  img {
    border-radius: 50%;
  }

  form {
    background: #fff;
    margin: 30px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 6px;

    .form-group {
      margin-bottom: 15px;
      label {
        display: block;
      }
      input,
      select {
        background: #fff;
        padding: 10px;
        width: calc(100% - 22px);
        border: 1px solid #ccc;
        border-radius: 4px;
        outline: none;
        &:focus {
          border: 1px solid var(--primary);
        }
      }

      select {
        width: 100%;
      }
    }

    button {
      background: var(--primary);
      width: 100%;
      padding: 15px;
      outline: none;
      border: 0;
      color: #fff;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 4px;

      &.disabled {
        background: var(--primary-disabled);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue